import { PerspectiveCamera, CameraManager, Grid, Debug, SceneManager, Screen, Graphics } from '../engine';

import { Color } from 'three';
import { Fog } from 'three';
import { AmbientLight } from 'three';
import { DirectionalLight } from 'three';
import { SpotLight } from 'three';
import { SpotLightHelper } from 'three';
import { CameraHelper } from 'three';
import { Object3D } from 'three';

import CameraController from '../camera_controller/CameraController';
import CameraSimpleState from '../camera_controller/states/CameraSimpleState';

class SceneController
{
  init()
  {
    this.camera_controller = new CameraController();
  }

  start()
  {
    this.__init_camera();
    this.__init_camera_controller();

    this.add_lights();

    // Debug.draw_sphere();
    // Debug.draw_axis();
    //SceneManager.current.add(new Grid());

    SceneManager.current.fog = new Fog( 0x050505, 50, 100 );

    // Here we add all objects into the scene
    // this.alley = new Alley();
    // SceneManager.current.add(this.alley);

    // Compile shaders on the first frame
    Graphics.update();

    // After the object is rendered, we hide it
    // this.alley.hide();
  }

  add_lights()
  {
    let light = new AmbientLight('#FFFFFF', 0.2);
    SceneManager.current.add(light);

    // let directional_light = new DirectionalLight('#FFFFFF', 1);
    // directional_light.position.set(0, 10, 20);
    // SceneManager.current.add(directional_light);

    const spotLight = new SpotLight( 0xffffff, 0.5 );
    spotLight.position.set( 1, 5, 3 );
    spotLight.angle = Math.PI / 8;
    spotLight.penumbra = 0.8;
    spotLight.decay = 2;
    spotLight.distance = 10;
    spotLight.target.position.x = -15;
    spotLight.target.updateMatrix = true;

    const targetObject = new Object3D();
    targetObject.position.x = 1;
    SceneManager.current.add(targetObject);
    spotLight.target = targetObject;

    spotLight.castShadow = true;
    spotLight.shadow.mapSize.width = 1024 * 2;
    spotLight.shadow.mapSize.height = 1024 * 2;
    spotLight.shadow.camera.near = 3.7;
    spotLight.shadow.camera.far = 5.9;
    spotLight.shadow.focus = 1.0;
    spotLight.shadow.bias =  -0.002;
    spotLight.shadow.radius = 20;

    SceneManager.current.add(spotLight);
    let shadowClone = spotLight.clone();
    shadowClone.shadow.mapSize.width = 1024 * 2;
    shadowClone.shadow.mapSize.height = 1024 * 2;
    shadowClone.shadow.camera.near = 3.7;
    shadowClone.shadow.camera.far = 5.9;
    shadowClone.shadow.focus = 1.0;
    shadowClone.shadow.bias = - 0.002;
    shadowClone.shadow.radius = 20;   
     
    SceneManager.frontScene.add(shadowClone);

    const targetObjectShadow = new Object3D();
    targetObjectShadow.position.x = 1;
    SceneManager.frontScene.add(targetObjectShadow);
    shadowClone.target = targetObjectShadow;

    const spotLight2 = new DirectionalLight( 0xffffff, 0.2 );
    spotLight2.position.set( 4, 6, 8 );

    SceneManager.current.add(spotLight);

    //const shadowCameraHelper = new CameraHelper( spotLight.shadow.camera );
    //SceneManager.current.add( shadowCameraHelper );

  }

  update()
  {
    this.camera_controller.update();
    // this.alley.update();
  }

  __init_camera()
  {
    let camera = new PerspectiveCamera(60, Screen.aspect_ratio, 0.1, 200);
    camera.updateProjectionMatrix();
    camera.position.z = 10;

    camera.clear_color.copy(new Color('#181818'));
    camera.clear_alpha = 1;
    camera.fov = 30
    CameraManager.current = camera;
  }

  __init_camera_controller()
  {
    this.camera_controller.set_camera(CameraManager.current);
    // this.camera_controller.set_idle();
    //this.camera_controller.set_standard_mode();
    this.camera_controller.set_state(new CameraSimpleState());

    this.camera_controller.min_zoom = 1;
    this.camera_controller.max_zoom = 40;
    this.camera_controller.reference_zoom = 5.5;
    this.camera_controller.reference_position.set(0, 0.3, 0);
    this.camera_controller.set_rotation(18, 65);

    // Expose for mobile bottom sheet zoom adjustment
    window._cdrCameraController = this.camera_controller;
  }
}

export default new SceneController();
